import { createRouter, createWebHistory } from 'vue-router';
import BaseStations from './views/BaseStations.vue';
import Alerts from './views/Alerts.vue';
import Reports from './views/Reports.vue';
import Admin from './views/Admin.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: { name: 'base-stations' },
    },
    {
      path: '/base-stations',
      name: 'base-stations',
      component: BaseStations,
      props: true
    },
    {
      path: '/alerts',
      name: 'alerts',
      component: Alerts,
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
    },
  ],
});

export default router;
